import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as dashboardActions from "src/redux/slices/dashboardSlice";
import AreaChartWrapper from "src/components/ui/chart/AreaChartWrapper";

interface StockMovementCardProps {
  days: number;
  enabled?: boolean;
}

const StockMovementCard: React.FC<StockMovementCardProps> = ({
  days,
  enabled = true,
}) => {
  const dispatch = useAppDispatch();
  const { tenantStockMovement } = useAppSelector((state) => state.dashboard);

  useEffect(() => {
    if (!enabled) return;
    dispatch(dashboardActions.getTenantStockMovementRequest({ days }));
  }, [dispatch, days, enabled]);

  if (!enabled) return null;

  const data = tenantStockMovement.data?.data || [];

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-gray-700">
          Stock in vs. Stock Out
        </h2>
        <span className="text-xs text-gray-400">Last {days} days</span>
      </div>
      <AreaChartWrapper data={data} />
    </div>
  );
};

export default StockMovementCard;
